import {BaseContainerModel} from '../base-container.model';
import {bl_fi_item_to_mrp_prodsys_link_RowClass} from '../../dbschema';

export class ItemToMrpProdsysLinkContainerModel extends BaseContainerModel {
  bl_fi_item_to_mrp_prodsys_link: bl_fi_item_to_mrp_prodsys_link_RowClass = new bl_fi_item_to_mrp_prodsys_link_RowClass();
}
